export const timeHr = (time) => {
  return Math.floor(time / 3600);
}

export const timeMin = (time) => {
  return Math.floor((time / 60) % 60);
}

export const isContentAvailable = (startTime, untilTime) => {
  const now = new Date().getTime();
  const startEventTime = new Date(startTime).getTime();
  return now >= startEventTime && now <= untilTime;
}

export const isContentLive = (startTime = '', endTime = '') => {
  const now = new Date().getTime();
  const startEventTime = new Date(startTime).getTime();
  const endEventTime = new Date(endTime).getTime();
  return startEventTime <= now && endEventTime >= now;
}
